import { phoneExtraSymbolsRegexp } from "@shared/constants/regExp";
/*
Принимает строку формата +7 (914) 534-12-21, возвращает строку, включающую в себя только плюс и цифры.
Если передается строка формата +89145341221, +8 заменяется на +7.
 */
export const phoneNumberNormalizer = (phone: string) => {
	const formattedPhoneNumber = phone.replace(phoneExtraSymbolsRegexp, "");
	const phoneCode = formattedPhoneNumber[1];
	if (phoneCode === "8") {
		return formattedPhoneNumber.replace("+8", "+7");
	}
	return formattedPhoneNumber;
};
